<div class="inbox-page">

  <!-- ================= HEADER ================= -->
  <div class="inbox-topbar">

    <div class="inbox-heading">
      <div class="inbox-heading-icon">
        <mat-icon>mail</mat-icon>
      </div>

      <div>
        <h4>Inbox</h4>
        <span>Messages & notifications</span>
      </div>
    </div>

    <div class="inbox-search">
      <mat-icon>search</mat-icon>

      <input
        type="text"
        placeholder="Search mail"
        [(ngModel)]="searchText"
      />

      <button
        *ngIf="searchText"
        type="button"
        class="search-clear"
        (click)="searchText = ''">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="topbar-actions">

      <button
        type="button"
        class="icon-btn"
        title="Refresh">
        <mat-icon>refresh</mat-icon>
      </button>

      <button
        type="button"
        class="icon-btn"
        title="Settings">
        <mat-icon>settings</mat-icon>
      </button>

    </div>

  </div>


  <!-- ================= MAIN ================= -->
  <div class="inbox-shell">


    <!-- ===================================== -->
    <!-- LEFT FOLDER PANEL -->
    <!-- ===================================== -->

    <aside class="mail-sidebar">

      <button class="compose-btn">
        <mat-icon>edit</mat-icon>
        <span>New Message</span>
      </button>


      <div class="folder-list">

        <button
          class="folder-item"
          [class.active]="selectedFolder === 'Inbox'"
          (click)="selectFolder('Inbox')">

          <div class="folder-name">
            <mat-icon>inbox</mat-icon>
            <span>Inbox</span>
          </div>

          <span class="folder-count">8</span>

        </button>


        <button
          class="folder-item"
          [class.active]="selectedFolder === 'Starred'"
          (click)="selectFolder('Starred')">

          <div class="folder-name">
            <mat-icon>star_border</mat-icon>
            <span>Starred</span>
          </div>

        </button>


        <button
          class="folder-item"
          [class.active]="selectedFolder === 'Sent'"
          (click)="selectFolder('Sent')">

          <div class="folder-name">
            <mat-icon>send</mat-icon>
            <span>Sent</span>
          </div>

        </button>


        <button
          class="folder-item"
          [class.active]="selectedFolder === 'Drafts'"
          (click)="selectFolder('Drafts')">

          <div class="folder-name">
            <mat-icon>description</mat-icon>
            <span>Drafts</span>
          </div>

          <span class="folder-count muted-count">2</span>

        </button>


        <button
          class="folder-item"
          [class.active]="selectedFolder === 'Archived'"
          (click)="selectFolder('Archived')">

          <div class="folder-name">
            <mat-icon>archive</mat-icon>
            <span>Archived</span>
          </div>

        </button>


        <button
          class="folder-item"
          [class.active]="selectedFolder === 'Trash'"
          (click)="selectFolder('Trash')">

          <div class="folder-name">
            <mat-icon>delete_outline</mat-icon>
            <span>Trash</span>
          </div>

        </button>

      </div>


      <div class="sidebar-divider"></div>


      <div class="folder-section-title">
        Categories
      </div>


      <div class="category-list">

        <div class="category-item">
          <span class="category-dot patient-dot"></span>
          <span>Patients</span>
        </div>

        <div class="category-item">
          <span class="category-dot verification-dot"></span>
          <span>Verification</span>
        </div>

        <div class="category-item">
          <span class="category-dot system-dot"></span>
          <span>System</span>
        </div>

      </div>

    </aside>



    <!-- ===================================== -->
    <!-- MESSAGE LIST -->
    <!-- ===================================== -->

    <section class="mail-list-panel">

      <div class="mail-list-header">

        <div>
          <h5>{{ selectedFolder }}</h5>
          <span>{{ filteredMails.length }} messages</span>
        </div>

        <div class="mail-list-tools">

          <button
            class="list-filter-btn active"
            type="button">
            All
          </button>

          <button
            class="list-filter-btn"
            type="button">
            Unread
          </button>

          <button
            type="button"
            class="list-more-btn">
            <mat-icon>more_horiz</mat-icon>
          </button>

        </div>

      </div>


      <div class="mail-list">

        <div
          *ngFor="let mail of filteredMails; trackBy: trackByMailId"
          class="mail-item"
          [class.active]="selectedMail && selectedMail.id === mail.id"
          [class.unread]="mail.unread"
          (click)="selectMail(mail)">


          <div class="mail-item-top">

            <div class="mail-user">

              <div
                class="mail-avatar"
                [ngClass]="mail.avatarClass">

                {{ getInitials(mail.sender) }}

              </div>


              <div class="mail-user-info">

                <div class="sender-row">

                  <span class="mail-sender">
                    {{ mail.sender }}
                  </span>

                  <span
                    *ngIf="mail.unread"
                    class="unread-dot">
                  </span>

                </div>

              </div>

            </div>


            <span class="mail-time">
              {{ mail.time }}
            </span>

          </div>


          <div class="mail-subject-row">

            <span class="mail-subject">
              {{ mail.subject }}
            </span>

            <button
              type="button"
              class="star-btn"
              [class.starred]="mail.starred"
              (click)="toggleStar($event, mail)">

              <mat-icon>
                {{ mail.starred ? 'star' : 'star_border' }}
              </mat-icon>

            </button>

          </div>


          <div class="mail-preview">

            {{ mail.preview }}

          </div>


          <div class="mail-meta">

            <span
              *ngIf="mail.category"
              class="mail-category">

              {{ mail.category }}

            </span>


            <span
              *ngIf="mail.hasAttachment"
              class="attachment-indicator">

              <mat-icon>attach_file</mat-icon>

            </span>

          </div>

        </div>


        <!-- EMPTY STATE -->

        <div
          class="mail-empty"
          *ngIf="filteredMails.length === 0">

          <mat-icon>search_off</mat-icon>

          <h5>No messages found</h5>

          <p>
            Try changing your search criteria.
          </p>

        </div>

      </div>

    </section>



    <!-- ===================================== -->
    <!-- READING PANE -->
    <!-- ===================================== -->

    <section class="reading-pane">


      <ng-container *ngIf="selectedMail; else noMailSelected">


        <!-- ACTION BAR -->

        <div class="reading-actions">

          <div class="reading-left-actions">

            <button
              type="button"
              class="reading-icon-btn"
              title="Reply">

              <mat-icon>reply</mat-icon>

            </button>


            <button
              type="button"
              class="reading-icon-btn"
              title="Forward">

              <mat-icon>forward</mat-icon>

            </button>


            <button
              type="button"
              class="reading-icon-btn"
              title="Archive">

              <mat-icon>archive</mat-icon>

            </button>


            <button
              type="button"
              class="reading-icon-btn"
              title="Delete">

              <mat-icon>delete_outline</mat-icon>

            </button>

          </div>


          <button
            type="button"
            class="reading-icon-btn">

            <mat-icon>more_horiz</mat-icon>

          </button>

        </div>


        <!-- SUBJECT -->

        <div class="reading-content">

          <div class="reading-subject-row">

            <h3>
              {{ selectedMail.subject }}
            </h3>


            <span
              *ngIf="selectedMail.category"
              class="reading-category">

              {{ selectedMail.category }}

            </span>

          </div>



          <!-- SENDER -->

          <div class="sender-detail">

            <div
              class="sender-avatar"
              [ngClass]="selectedMail.avatarClass">

              {{ getInitials(selectedMail.sender) }}

            </div>


            <div class="sender-information">

              <div class="sender-title">

                <strong>
                  {{ selectedMail.sender }}
                </strong>

                <span class="sender-email">
                  &lt;{{ selectedMail.email }}&gt;
                </span>

              </div>


              <div class="recipient">

                To: {{ selectedMail.to }}

              </div>

            </div>


            <div class="message-date">

              {{ selectedMail.fullDate }}

            </div>

          </div>



          <!-- MESSAGE BODY -->

          <div class="message-body">

            <p>
              Hi,
            </p>


            <p>
              {{ selectedMail.body }}
            </p>


            <p *ngIf="selectedMail.bodySecond">
              {{ selectedMail.bodySecond }}
            </p>


            <p>
              Regards,<br>
              <strong>{{ selectedMail.sender }}</strong>
            </p>

          </div>



          <!-- ATTACHMENT -->

          <div
            *ngIf="selectedMail.hasAttachment"
            class="attachment-section">

            <div class="attachment-title">

              <mat-icon>attach_file</mat-icon>

              <span>
                1 Attachment
              </span>

            </div>


            <div class="attachment-card">

              <div class="attachment-file-icon">
                <mat-icon>description</mat-icon>
              </div>


              <div class="attachment-info">

                <strong>
                  Patient_Verification.pdf
                </strong>

                <span>
                  428 KB
                </span>

              </div>


              <button
                type="button"
                class="attachment-download">

                <mat-icon>download</mat-icon>

              </button>

            </div>

          </div>



          <!-- REPLY -->

          <div class="quick-reply">

            <button type="button">
              <mat-icon>reply</mat-icon>
              Reply
            </button>


            <button type="button">
              <mat-icon>forward</mat-icon>
              Forward
            </button>

          </div>

        </div>

      </ng-container>



      <!-- NO MAIL SELECTED -->

      <ng-template #noMailSelected>

        <div class="no-mail-selected">

          <div class="empty-mail-icon">
            <mat-icon>mark_email_unread</mat-icon>
          </div>

          <h4>Select a message</h4>

          <p>
            Choose an email from the list to view its contents.
          </p>

        </div>

      </ng-template>

    </section>

  </div>

</div>